const autoNgTemplateLoaderTemplate1 = require('./edgeJobsView.html');

import angular from 'angular';
import { EdgeJobsViewController } from './edgeJobsViewController';

angular.module('shbdeployer.edge').component('edgeJobsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: EdgeJobsViewController,
});
